import React from 'react';
import { useStore } from '../../store/useStore';
import { CheckCircle2 } from 'lucide-react';
export function ClaimResult() {
  const {
    setShopperView
  } = useStore();
  return <div className="flex flex-col h-full bg-[#F4F5F6] p-4 pt-12" data-id="element-413">
      <div className="bg-white rounded-[18px] p-6 shadow-sm flex flex-col items-center text-center" data-id="element-414">
        <div className="w-16 h-16 bg-[#E9FAF8] rounded-full flex items-center justify-center mb-4" data-id="element-415">
          <CheckCircle2 className="w-8 h-8 text-[#00CDBE]" data-id="element-416" />
        </div>
        <h1 className="text-2xl font-bold text-[#252935] mb-2" data-id="element-417">
          We will make it right.
        </h1>
        <p className="text-[#60646F] mb-6" data-id="element-418">
          Thanks for letting us know. We've applied a credit to your account for
          the difference.
        </p>

        <div className="w-full bg-[#F4F5F6] rounded-xl p-4 mb-8 text-left" data-id="element-419">
          <div className="flex justify-between items-center" data-id="element-420">
            <span className="text-[#252935] font-medium" data-id="element-421">
              Stash Guarantee Credit
            </span>
            <span className="font-bold text-[#007E7A]" data-id="element-422">+$10.00</span>
          </div>
        </div>

        <button onClick={() => setShopperView('Browse')} className="w-full bg-[#00CDBE] text-white font-bold py-3.5 rounded-full hover:bg-[#00B8AA] transition-colors" data-id="element-423">
          Done
        </button>
      </div>
    </div>;
}